module.exports = __webpack_public_path__ + "static/media/dashboard_darkbleu.66df2ca3.svg";